import { render, staticRenderFns } from "./SlotScopeWatcher.vue?vue&type=template&id=48826f67"
import script from "./SlotScopeWatcher.vue?vue&type=script&lang=js"
export * from "./SlotScopeWatcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports